import React, { forwardRef } from "react";
import { NavLink } from 'react-router-dom';

// crated for MUI tooltip: see https://mui.com/material-ui/react-tooltip/#custom-child-element
export const WrappedNavLink = forwardRef((props, ref) => {
  return <NavLink {...props} ref={ref} />;
});